module.exports = __webpack_public_path__ + "img/04-illu-kafu2021.7cc1cdcf.png";